import * as React from 'react';
import { UIHeading2, UIText1 } from '@cian/ui-kit';
import * as styles from './NotFoundForFilters.css';

export const NotFoundForFilters: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['image']} />
      <div>
        <UIHeading2>У нас ещё нет посёлков по такому запросу</UIHeading2>
        <div className={styles['description']}>
          <UIText1>Попробуйте изменить что-нибудь в фильтрах</UIText1>
        </div>
      </div>
    </div>
  );
};
